var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav-bar" }, [
    _c("ul", { staticClass: "nav-bar-list" }, [
      _c("li", [
        _c(
          "button",
          {
            staticClass: "nav-bar-list-button",
            class: _vm.showMarked && "nav-bar-list-button-active",
            attrs: { type: "button", title: "对比" },
            on: { click: _vm.retweet }
          },
          [_c("i", { staticClass: "fa fa-retweet" })]
        )
      ]),
      _c("li", [
        _c(
          "button",
          {
            staticClass: "nav-bar-list-button",
            class: _vm.showEditor && "nav-bar-list-button-active",
            attrs: { type: "button", title: "源码" },
            on: { click: _vm.toggleEditor }
          },
          [_c("i", { staticClass: "fa fa-code" })]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-391db771", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-391db771","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./examples/components/navbar.vue
// module id = null
// module chunks = 